import { css } from '@emotion/react';
import { theme } from 'global';

export const requirementIconSuccessColor = theme.colors.success;
export const requirementIconNeutralColor = theme.colors.neutral[400];
export const requirementIconErrorColor = theme.colors.danger;

export const container = css`
  width: 100%;
`;

export const formFields = css`
  display: flex;
  flex-direction: column;
  gap: 22px;
`;

export const passwordField = css`
  margin: 0 !important;

  .MuiOutlinedInput-root {
    border-radius: 6px;
    padding-right: 14px;
  }

  .MuiOutlinedInput-input {
    color: ${theme.colors.secondary};
  }

  .MuiInputLabel-root {
    color: ${theme.colors.neutral[500]};
  }

  .MuiInputLabel-root.MuiInputLabel-shrink {
    transform: translate(14px, -8px) scale(0.75);
  }

  .MuiOutlinedInput-notchedOutline {
    border-color: ${theme.colors.neutral[400]};
  }

  .MuiFormHelperText-root {
    margin-left: 0;
    margin-right: 0;
  }

  .MuiInputAdornment-root {
    display: flex;
  }
`;

export const requirementsCard = css`
  background: ${theme.colors.neutral[0]};
  border-radius: 6px;
  padding: 14px 24px;
  margin-top: -4px;
`;

export const requirementsList = css`
  margin: 0;
  padding: 0;
  list-style: none;

  li + li {
    margin-top: 10px;
  }
`;

export const requirementItem = css`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

export const requirementIconBase = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  flex-shrink: 0;

  svg {
    display: block;
    width: 20px;
    height: 20px;
  }
`;

export const requirementPendingDot = css`
  ${requirementIconBase};

  &::before {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${theme.colors.neutral[400]};
  }
`;

export const requirementText = (_isSatisfied: boolean) => css`
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  color: ${theme.colors.neutral[500]};
`;

export const actions = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 40px;
`;

export const backButton = css`
  padding: 0;
  min-width: auto;
  justify-content: flex-start;

  &:hover,
  &:active,
  &:focus {
    background: none;
    box-shadow: none;
  }
`;

export const primaryButton = css`
  min-width: fit-content;
  min-height: 56px;
`;

export const iconButton = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  padding: 0;
  cursor: pointer;
`;

export const eyeIcon = css`
  color: ${theme.colors.neutral[500]};
`;
